import React, { JSX, ReactNode } from "react";
import { EditPropsType, TableColumnType } from "../CatalogTable";
import { SorterResult } from "antd/es/table/interface";

// columns
import { renderPhotoColumn } from "./renderPhotoColumn";
import { renderNameColumn } from "./renderNameColumn";
import { renderCategoryColumn } from "./renderCategoryColumn";
import { renderBKCategoryColumn } from "./renderBKCategoryColumn";
import { renderPriceColumn } from "./renderPriceColumn";
import { renderCreatedAtColumn } from "./renderCreatedAtColumn";
import { renderUpdatedAtColumn } from "./renderUpdatedAtColumn";
import { renderDownloadSourceColumn } from "./renderDownloadSourceColumn";
import { renderStatusColumn } from "./renderStatusColumn";
import { renderDateTimeColumn } from "./renderDateTimeColumn";
import { renderCatalogueTypeColumn } from "./renderCatalogueTypeColumn";
import { renderPeriodicityColumn } from "./renderPeriodicityColumn";
import { renderFileTypeColumn } from "./renderFileTypeColumn";
import { renderFileColumn } from "./renderFileColumn";
import { renderActionsColumn } from "./renderActionsColumn";
import { renderEditableBKCategoryColumn } from "./renderEditableBKCategoryColumn";
import { renderSupplierCategoryColumn } from "./renderSupplierCategoryColumn";
import { renderProductsCountColumn } from "./renderProductsCountColumn";

export const renderColumns = (
  column: TableColumnType,
  renderActions: (entity: any, idx: number) => ReactNode,
  sorter: SorterResult<any>,
  onClickHandler?: (...args: any[]) => void,
  editOptions?: EditPropsType
): JSX.Element => {
  const renderColumnTitle = (title: string | JSX.Element): JSX.Element => (
    <span className="secondary-color break-normal">{title}</span>
  );

  const columnRenderFunctions: Record<TableColumnType, JSX.Element> = {
    photo: renderPhotoColumn(renderColumnTitle),
    name: renderNameColumn(renderColumnTitle, sorter),
    category: renderCategoryColumn(renderColumnTitle, sorter),
    category_supplier: renderSupplierCategoryColumn(renderColumnTitle, sorter),
    bk_category: renderBKCategoryColumn(renderColumnTitle, sorter),
    editable_bk_category: renderEditableBKCategoryColumn(renderColumnTitle, editOptions, sorter),
    price: renderPriceColumn(renderColumnTitle, sorter),
    created_at: renderCreatedAtColumn(renderColumnTitle, sorter),
    updated_at: renderUpdatedAtColumn(renderColumnTitle, sorter),
    download_source: renderDownloadSourceColumn(renderColumnTitle, sorter),
    status: renderStatusColumn(renderColumnTitle, sorter, onClickHandler),
    date_time: renderDateTimeColumn(renderColumnTitle, sorter, onClickHandler),
    catalogue_type: renderCatalogueTypeColumn(renderColumnTitle, sorter, onClickHandler),
    products_count: renderProductsCountColumn(renderColumnTitle, sorter),
    periodicity: renderPeriodicityColumn(renderColumnTitle, sorter),
    source: renderFileTypeColumn(renderColumnTitle, sorter, onClickHandler),
    file: renderFileColumn(renderColumnTitle),
    actions: renderActionsColumn(renderActions),
  };

  return columnRenderFunctions[column];
};
